export const mailchimpSettings = {
  integrationMailchimp: false,
  integrationMailchimpAuth: undefined,
  integrationMailchimpList: '',
  integrationMailchimpFieldsMap: []
};

export type MailchimpSettings = typeof mailchimpSettings;
